import PaymentTypeSection from './PaymentTypeSection';

export default PaymentTypeSection;
